import React, { Component } from 'react'
import ReactTextCollapse from 'react-text-collapse' 
import ArrowR from '@material-ui/icons/ArrowForward'
import { css } from '@emotion/core'
import Div from '../components/Div/Div.styles'
import ds from '../theme'
import { mq } from '../components/styles/Layout.styles'
import H4 from '../components/H4'
import H5 from '../components/H5'
import Paragraph from '../components/Paragraph'
import Subtitle from '../components/SubTitle2'

import { scrollAction } from '../components/styles/InternalPage.styles'

const TEXT_COLLAPSE_OPTIONS = { 
  collapse: false, 
  collapseText: '+ Mais detalhes', 
  expandText: '- Ocultar detalhes', 
  minHeight: 0, 
  maxHeight: 620,
  marginTop: 54, 
  overflow: 'hidden !important',
  textStyle: { 
    color: '#44474e', 
    fontSize: '14px' ,
    lineHeight: 1.71,
    marginTop: '54px',
    textAlign: 'center',
    width: '100%',
    cursor: 'pointer'
  }
}

const PCIDSS = ({
  licenceName,
  licenceDescription,
  licenceIso,
  licenceBenefits,
  benefitsDescription,
  benefitsDescription2,
  benefitsDescription3,
}) => {
  return (
    <div
      style={{
        padding: '50px 24px 24px 24px',
        backgroundColor: '#ffffff',
        border: 'solid 1px rgba(0, 0, 0, 0.12)',
        borderRadius: 12
      }}
      css={
        [css(
          mq({
            '&:not(:last-child)': {
              marginBottom: ds.space(3)
            } 
          })
        ),
        // item  
      ]
      }
    >
      <Div
        flexDirection='column'
        alignItems='center'
      >
        <H4
          selected
          on='onSurface'
          variant='highEmphasis'
          style={{
            letterSpacing: 0.25,
            marginBottom: 50,
            width: 296,
            textAlign: 'center'
          }}
        >
          {licenceName}
        </H4>
        <Div
          style={{
            width: 200,
            height: 60,
            borderRadius: 30,
            border: 'solid 1px #44474e',
            justifyContent: 'center',
            marginBottom: 17
          }}
        >
          <Subtitle
            style={{
              fontSize: 14,
              fontWeight: 600,
              lineHeight: 1.5,
              letterSpacing: 2.38,
              textAlign: 'center',
              color: '#44474e',
              whiteSpace: 'pre-wrap'
            }}
          >
            {licenceIso}
          </Subtitle>
        </Div>
        <ReactTextCollapse
          options={TEXT_COLLAPSE_OPTIONS}
          css={scrollAction}
        >
          <Div 
            style={{
              width: 200,
              height: 1,
              borderBottom: 'solid 1px #e0e0e0',
              margin: '0 auto',
              marginTop: 20,
              marginBottom: 20
            }}
          />
          <Paragraph
            style={{
              fontSize: 14,
              lineHeight: 1.7,
              textAlign: 'center',
              color: 'rgba(0, 0, 0, 0.6)'
            }}
          >
            {licenceDescription}
          </Paragraph>
          <Div 
            style={{
              width: 200,
              height: 1,
              borderBottom: 'solid 1px #e0e0e0',
              margin: '0 auto',
              marginTop: 20,
              marginBottom: 20
            }}
          />
          <H5 
            style={{
              fontSize: 23.7,
              textAlign: 'center',
              fontWeight: 500,
              color: 'rgba(0, 0, 0, 0.87)',
              marginTop: 10,
              marginBottom: 24,
              whiteSpace: 'pre-wrap'
            }}>
            {licenceBenefits}
          </H5>
          <Div
            style={{
              display: '-webkit-box',
              marginBottom: 16
            }}
          >
            <ArrowR 
              style={{
                color: 'rgba(78, 81, 89, 0.54)'
              }}
            />
            <Paragraph
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                textAlign: 'left',
                width: 240,
                marginLeft: 16,
                color: 'rgba(0, 0, 0, 0.6)'
              }}
            >
              {benefitsDescription}
            </Paragraph>
          </Div>
          <Div
            style={{
              display: '-webkit-box',
              marginBottom: 16
            }}
          >
            <ArrowR 
              style={{
                color: 'rgba(78, 81, 89, 0.54)'
              }}
            />
            <Paragraph
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                textAlign: 'left',
                width: 240,
                marginLeft: 16,
                color: 'rgba(0, 0, 0, 0.6)'
              }}
            >
              {benefitsDescription2}
            </Paragraph>
          </Div>
          <Div
            style={{
              display: '-webkit-box'
            }}
          >
            <ArrowR 
              style={{
                color: 'rgba(78, 81, 89, 0.54)'
              }}
            />
            <Paragraph
              style={{
                fontSize: 14,
                lineHeight: 1.7,
                textAlign: 'left',
                width: 240,
                marginLeft: 16,
                color: 'rgba(0, 0, 0, 0.6)'
              }}
            >
              {benefitsDescription3}
            </Paragraph>
          </Div>
        </ReactTextCollapse>
      </Div>
    </div>
  )
}

class CertificadoPCIDSS extends Component {
  render () {
    return (
      <div>
        <PCIDSS
          licenceName='Certificado'
          licenceIso={`PCI-DSS`}
          licenceDescription='Para garantir a proteção de dados nas transações de cartões de créditos, a HostDime Brasil está em conformidade e possui certificação PCI-DSS (Payment Card Industry Data Security Standard).'
          licenceBenefits={`Diferenciais`}
          benefitsDescription='Garantia na qualidade de serviços oferecidos, agregados com a preocupação na segurança de informação;'
          benefitsDescription2='Garantia de requisitos mínimos no ambiente de TI para processamento de dados de pagamento em cartões de crédito;'
          benefitsDescription3='Incentivo na melhoria constante com um programa de gerenciamento constante de vulnerabilidade de segurança;'
        />
      </div>
    )
  }
}

export default CertificadoPCIDSS